import { Datalayer, OnDatalayerMapper } from '@/features/shared/HOCs/withGTM.interface';
import {
  DLTargetSelectors,
  DLTabsEvents,
  DLTabsEventNames,
} from '@/features/shared/HOCs/withGTM.constant';
import { getTabIndex } from '@/datalayer/App.datalayer.utils';
import { mapTargetBySelectors } from '@/features/shared/HOCs/withGTM';
import { linkStrategy } from '@/App.datalayer';

export const tabbedEventTargets = mapTargetBySelectors([DLTargetSelectors.Tab]);

export const onDatalayerTabClick: OnDatalayerMapper = ({ target }) => {
  if (!target) return undefined;

  const title = target?.textContent;
  const targetId = target?.id;

  return {
    event: DLTabsEvents.TabClick,
    event_name: DLTabsEventNames.TabClick,
    ...(title !== '' && { title }),
    index_num: getTabIndex(targetId).toString() || '',
  };
};
